const $window = $(window)

export function initSlippy() {
	$window.once('slippy').each(function () {
		const $header = $('.header')
		const $cta = $header.find('.site-cta')
		if (!$cta.length) {
			return
		}

		const height = $cta.height.bind($cta)
		const min = () => height() * -1
		const max = 0

		let lastScrollTop = $window.scrollTop()
		let scrollTop = 0
		let isPaused = false

		$window.on('scroll', null, {passive: true}, () => {
			if (isPaused) {
				return
			}

			scrollTop = $window.scrollTop()
			const scrollMaxY = document.body.scrollHeight - window.innerHeight
			if (scrollTop > scrollMaxY) {
				// Overscroll! So, just ignore it.
				return
			}
			const diff = lastScrollTop - scrollTop
			lastScrollTop = scrollTop

			if (scrollTop <= 0) {
				slippyTop = max
			} else if (scrollTop >= 0 && scrollTop <= height()) {
				add(diff)
			} else if (scrollTop >= height()) {
				slippyTop = min()
			}

			update()
		})

		let siteCtaMessageTimeout
		$window.on('siteCta:setTemporaryMessage', function (e, {message, action}) {
			clearTimeout(siteCtaMessageTimeout)
			const oldMessage = $cta.html()
			// isPaused = true
			$cta.html(`<p style="cursor: pointer">${message}</p>`)
			$cta.on('click', onClick)

			// siteCtaMessageTimeout = setTimeout(function () {
			// 	isPaused = false
			// 	$cta.html(oldMessage)
			// 	$cta.off('click', onClick)
			// }, 3000)

			function onClick() {
				$window.trigger(action)
			}
		})


		function bind(value, min, max) {
			return Math.max(Math.min(value, max), min)
		}

		let slippyTop = 0
		let lastSetTop = 0

		function add(amount) {
			slippyTop = bind(slippyTop + amount, min(), max)
		}

		function set(newValue) {
			slippyTop = bind(newValue, min(), max)
		}

		function map(value, min1, max1, min2, max2) {
			const span1 = max1 - min1
			const span2 = max2 - min2
			return min2 + (value - min1) / span1 * span2
		}

		function update() {
			if (slippyTop !== lastSetTop) {
				$header.stop(true).css('top', `${slippyTop}px`)
				// Let everyone know that something has changed!
				$window.trigger('slippy:update', {slippyTop, min: min(), max})
				lastSetTop = slippyTop
			}
		}
	})
}